import React from 'react'

import classNames from 'classnames'

import styles from './index.module.css'

export interface Props {
  /**
   * Additional classname
   */
  className?: string

  /**
   * Value to display
   */
  children?: React.ReactNode

  /**
   * Maximum number of rows to display
   */
  maxRows?: number

  /**
   * Dimension
   */
  size?: 'XS' | 'S' | 'M' | 'XL'
}

const PreTitle: React.FC<Props> = ({
  className,
  children,
  maxRows = 1,
  size = 'S',
}: Props): JSX.Element | null => {
  if (!Boolean(children)) {
    return null
  }

  return (
    <div
      className={classNames(
        styles.wrapper,
        styles[`rows-${maxRows}`],
        styles[`size-${size.toLowerCase()}`],
        className || styles.default
      )}
    >
      {children}
    </div>
  )
}

export default PreTitle
